"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
require("./index.scss");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var RequestedAmount = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(RequestedAmount, _React$Component);
  var _super = _createSuper(RequestedAmount);
  function RequestedAmount() {
    (0, _classCallCheck2.default)(this, RequestedAmount);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(RequestedAmount, [{
    key: "render",
    value: function render() {
      var _this = this;
      var adsMinAllowed = 499;
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "root"
      }, this.props.value.originalTransaction ? /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "additional-transaction"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-12"
      }, "Additional transaction for ", /*#__PURE__*/_react.default.createElement("strong", null, " ", this.props.value.originalTransaction.firstName, " ", this.props.value.originalTransaction.lastName, " ")), /*#__PURE__*/_react.default.createElement("div", {
        className: "close-modal"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "pull-right",
        "data-dismiss": "modal"
      }, "X")))) : null, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "available-credit-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "available-credit-container__text"
      }, "Available credit"), /*#__PURE__*/_react.default.createElement("div", {
        className: "available-credit-container__amount"
      }, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
        value: Math.ceil(this.props.value.limits.maximum),
        displayType: 'text',
        thousandSeparator: true,
        prefix: '$',
        allowNegative: false
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "flex"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "available-credit-container__requested"
      }, "Amount requested :"), this.props.value.limits && this.props.value.limits.maximum < adsMinAllowed ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
        className: "available-credit-container__input",
        disabled: true
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "loanAmount-error-message",
        "data-error-for": "loanAmount"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "icon icon-form-error error-image"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "text-nowrap error-text",
        "data-aid": "error-text"
      }, "Plan amounts $499 - $32000"))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
        className: "available-credit-container__input",
        displayType: 'number',
        thousandSeparator: true,
        prefix: '$',
        allowNegative: false,
        decimalScale: 0,
        onValueChange: function onValueChange(e, value) {
          return _this.props.updateTextCB(e.floatValue);
        }
      }), this.props.inValidInput ? /*#__PURE__*/_react.default.createElement("div", {
        className: "loanAmount-error-message",
        "data-error-for": "loanAmount"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "icon icon-form-error error-image"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "text-nowrap error-text",
        "data-aid": "error-text"
      }, "Please enter an amount between $", this.props.minAllowed, " and $", this.props.value.limits.maximum)) : null)))));
    }
  }]);
  return RequestedAmount;
}(_react.default.Component);
RequestedAmount.propTypes = {
  value: _propTypes.default.arrayOf({
    amountRemaining: _propTypes.default.arrayOf({
      returnCode: _propTypes.default.string,
      otbAmount: _propTypes.default.number
    }),
    limits: _propTypes.default.arrayOf({
      maximum: _propTypes.default.number,
      minimum: _propTypes.default.string
    }),
    originalTransaction: _propTypes.default.arrayOf({
      firstName: _propTypes.default.string,
      lastName: _propTypes.default.string,
      rate: _propTypes.default.string,
      term: _propTypes.default.string,
      introTerm: _propTypes.default.string,
      payment: _propTypes.default.string,
      loanAmount: _propTypes.default.string,
      productType: _propTypes.default.string,
      isInterestFree: _propTypes.default.string,
      isPRP: _propTypes.default.string,
      loanAmountDisplay: _propTypes.default.string
    })
  }),
  updateTextCB: _propTypes.default.string,
  inValidInput: _propTypes.default.bool,
  minAllowed: _propTypes.default.number,
  maxAllowed: _propTypes.default.number
};
var _default = RequestedAmount;
exports.default = _default;
